import { connectWithHammock, ENDPOINTS } from 'hammock';
import React from 'react';
import { Helmet } from 'react-helmet';
import { Outlet } from 'react-router-dom';

import { useNavigation } from 'commons/hooks';
import { View } from 'dashboard/components/View';
import AccordillonMenu from 'dashboard/containers/AccordillonMenu';
import { SEGMENTS_PATH } from 'dashboard/pages/Segments';
import { SEGMENT_LIST_ROUTE } from 'dashboard/pages/Segments/constants';

import { ANALYTICS_ROUTE } from './pages/Analytics';
import { DEFINITION_ROUTE } from './pages/Definition';
import { MEMBERSHIP_DEBUGGER_ROUTE } from './pages/MembershipDebugger/constants';
import { SETTINGS_ROUTE } from './pages/Settings/constants';

export const SegmentExisting = ({ resource }: { resource: any }) => {
  const navigate = useNavigation();
  // for certain orgs with a large MAU count, we disable segment users

  return (
    <View
      titleLvl3={resource.name || 'Untitled segment'}
      handleGoBack={() => navigate(`${SEGMENTS_PATH}/${SEGMENT_LIST_ROUTE.path}`)}
      subheader={
        <AccordillonMenu
          pages={[DEFINITION_ROUTE, ANALYTICS_ROUTE, SETTINGS_ROUTE, MEMBERSHIP_DEBUGGER_ROUTE]}
        />
      }
    >
      <Helmet title="Segment | Candu" />
      <Outlet context={{ segmentId: resource.id }} />
    </View>
  );
};

export default connectWithHammock(({ segmentId }) => ({
  endpoint: ENDPOINTS.segmentsDefinition,
  id: segmentId,
}))(SegmentExisting);
